import type { VisitOptions } from "@inertiajs/core";
import { router } from "@inertiajs/react";
import { RouterProvider as AriaRouterProvider } from "@ui/primitives/shared";
import type { PropsWithChildren } from "react";

declare module "react-aria-components" {
  interface RouterConfig {
    href: string;
    routerOptions: RouterOptions;
  }
}

export type RouterOptions = Pick<VisitOptions, "replace" | "viewTransition">;

const ABSOLUTE_URL = /^https?:\/\//i;

function inertiaNavigate(to: string | URL, options?: RouterOptions) {
  const url = String(to);
  if (ABSOLUTE_URL.test(url)) {
    if (options?.replace) {
      // biome-ignore lint/plugin/no-window-location: Bridge to native navigation for absolute URLs
      window.location.replace(url);
    } else {
      // biome-ignore lint/plugin/no-window-location: Bridge to native navigation for absolute URLs
      window.location.href = url;
    }
    return;
  }
  router.visit(url, {
    replace: options?.replace,
    viewTransition: options?.viewTransition,
  });
}

export interface RouterProviderProps extends PropsWithChildren {
  navigate?: (path: string | URL, options?: RouterOptions) => void;
}

export function RouterProvider({ children, navigate = inertiaNavigate }: RouterProviderProps) {
  return <AriaRouterProvider navigate={navigate}>{children}</AriaRouterProvider>;
}
